import type { OperationContext } from 'urql';

// Public catalog queries do not need the NextAuth cookie. In particular, a
// gateway on another localhost port cannot necessarily decrypt this app's session.
export const publicGraphqlContext: Partial<OperationContext> = {
  fetchOptions: {
    credentials: 'omit',
    headers: { authorization: `Bearer ${process.env.NEXT_PUBLIC_CMS_API_TOKEN ?? ''}` },
  },
};
